import { ICopyable } from '../controls/common/icopyable';
import { IDisplayableItem } from './interfaces/displayable-item.interface';
import { IDocumentType } from './interfaces/document-type.interface';

export class DocumentType implements ICopyable<DocumentType>, IDisplayableItem {
    id: number = null;
    name: string = null;
    defaultBoxId: string = null;

    public createCopy(): DocumentType {
        const instance = new DocumentType();
        instance.id = this.id;
        instance.name = this.name;
        instance.defaultBoxId = this.defaultBoxId;

        return instance;
    }

    public static createFormCopy(documentType: DocumentType): IDocumentType {
        const instance = new DocumentType();
        instance.id = documentType.id;
        instance.name = documentType.name;
        instance.defaultBoxId = documentType.defaultBoxId;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.name = other.name;
        this.defaultBoxId = other.defaultBoxId;
    }

    public getDisplayName() {
        return `${this.name}`;
    }

    get displayName(): string {
        return `${this.name}`;
    }
}
